var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolicitationsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.2 16",
    style: {
      enableBackground: "new 0 0 16.2 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.8,4.5C15.4,4.3,15,4.1,14.6,4v9.4c-0.9-0.3-1.8-0.5-2.7-0.5c-1.5,0-2,0.4-3.3,1.2V4.7 C7.3,4,5.8,3.5,4.3,3.5c-1.4,0-2.7,0.3-3.9,0.9C0.2,4.6,0,4.9,0,5.2v9.4c0,0.5,0.4,0.8,0.8,0.8c0.1,0,0.2,0,0.4-0.1 c0.9-0.5,2-0.8,3.1-0.8c1.6,0,3.1,0.6,4.3,1.6c1.2-0.9,1.7-1.6,3.3-1.6c1.1,0,2.2,0.3,3.1,0.8c0.1,0.1,0.2,0.1,0.4,0.1 c0.4,0,0.8-0.3,0.8-0.8V5.2C16.2,4.9,16,4.6,15.8,4.5z M7,13.4c-0.9-0.3-1.8-0.5-2.7-0.5c-0.9,0-1.8,0.2-2.7,0.5V5.6 c0.9-0.4,1.8-0.6,2.7-0.6c0.9,0,1.9,0.2,2.7,0.6V13.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.9,2.1l0.5-0.5c0.2-0.2,0.2-0.6,0-0.9l-0.6-0.6c-0.2-0.2-0.6-0.2-0.9,0l-0.5,0.5L14.9,2.1z M14.5,2.6 l-3.6,3.6H9.4V4.8L13,1.2L14.5,2.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolicitationsIcon);
export default __webpack_public_path__ + "static/media/solicitations_icon.d6a64b80eb20fb95244fae9014998d32.svg";
export { ForwardRef as ReactComponent };